import { TableCell } from '@mui/material';

const BSTableBodyCell = ({ children, ...props }) => {
  return (
    <TableCell
      component="th"
      scope="row"
      sx={{ color: 'text.primary', borderBottom: 'none' }}
      {...props}>
      {children}
    </TableCell>
  );
};

export default BSTableBodyCell;
